import { pickBy } from '@/utils'
import CompHotSetting from "../../comps/comp_hotSetting";
import setupInfo from "./attr-setupInfo";

export default {
  name: 'newMemberInfo',
  setting: [
    { label: "楼层", key: "floor_var", component: "input", required: true },
    {
      label: "背景图",
      key: "backgroundImg",
      component: function (h, { key }) {
        return (
          <CompHotSetting v-model={this.value[key]} uuid={this.value.uuid} />
        );
      },
      value: { imgUrl: "", data: [] },
    },
    {
      label: "基础信息位置",
      key: "setupInfo",
      component: function (h, { key }) {
        return (
          <setupInfo
            v-model={this.value[key]}
            uuid={this.value.uuid}
          />
        );
      },
      value: {
        left: 10,
        top: 10,
        color: "#000000",
      },
    },
    { label: "完善资料描述", key: "perfectInfo", component: "input", required: true },
  ],
  transformIn: (v) => {
    const { name, base = {}, config } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut: (v) => {
    const { backgroundImg: { flowName_var, imgUrl, data }, floor_var, perfectInfo } = v

    if (!floor_var) {
      throw '[挂件]会员信息 请输入楼层';
    }
    if (imgUrl && !flowName_var) {
      throw '[挂件]热区图 请输入热区设置-资源位名称';
    }
    if (!perfectInfo) {
      throw '[挂件]会员信息 请输入完善资料描述';
    }
    for (let i in data) {
      if (data[i].id == "registerActivity" && !data[i].exchangeActivityTitle) {
        throw '[挂件]热区图 请输入热区设置-活动名称';
      }
      if (!data[i].imgName) {
        throw '[挂件]热区图 请输入热区设置-热区名称';
      }
    }

    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          floor_var: "floor_var",
        });
      },
      config: (v) => {
        return pickBy(v, {
          backgroundImg: "backgroundImg",
          setupInfo: "setupInfo",
          perfectInfo: "perfectInfo"
        });
      },
    })
  }
}
